import { alpha } from '@mui/material';
const usePButtonGroupStyles = () => {
    return {
        root: {
            width: '100%',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.24)}`,
            borderRadius: '14px',
            background: (theme) => theme.palette.common.grey8,
            p: 1.5,
            minHeight: 'auto'
        },
        label: {
            fontSize: '14px',
            fontWeight: 500,
            color: (theme) => theme.palette.text.primary
        },
        container: {
            display: 'grid',
            gridTemplateColumns: {
                xs: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))'
            },
            gap: 1,
            width: '100%'
        },
        option: {
            width: '100%',
            minWidth: 0,
            maxWidth: '100%',
            minHeight: 40,
            height: 40,
            boxSizing: 'border-box',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 1.5,
            borderRadius: '14px',
            backgroundColor: 'transparent',
            border: (theme) => `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
            color: (theme) => theme.palette.text.primary
        }
    };
};
export default usePButtonGroupStyles;
